/* Harmony Elements — content-to-cart blocks.
   Renders <div class="dn-picks" data-handles="a,b"> and <div class="dn-reads" data-articles="h|T">
   anywhere: page bodies, article bodies, theme sections. Product data is fetched live so a
   price change never leaves a stale number in a blog post. */
(function () {
  var CSS = '.dn-x{--gold:#C6A24C;--goldd:#997A30;--ink:#2B2622;--line:rgba(43,38,34,.14);' +
    '--paper:#FBF8F1;--green:#3F6B4A;--greenbg:#E6EFE4;max-width:760px;margin:38px auto 0;' +
    "font-family:'EB Garamond',Georgia,serif;color:var(--ink)}" +
    '.dn-x__h{font-family:"Cormorant Garamond",Georgia,serif;font-weight:600;font-size:1.5rem;' +
    'margin:0 0 4px}.dn-x__s{color:rgba(43,38,34,.62);margin:0 0 16px;font-size:1rem}' +
    /* cap the column so a card is the same size in a 1360px cart page as in an 883px
       product column — uncapped, the cart row rendered 440px images */
    '.dn-x__grid{display:grid;grid-template-columns:repeat(3,minmax(0,300px));gap:14px;' +
    'justify-content:start}' +
    /* carousel: every card that fits, scrolling right — used by the product page rows */
    '.dn-x__carousel{display:flex;gap:14px;overflow-x:auto;scroll-snap-type:x proximity;' +
    'padding:2px 2px 10px;-webkit-overflow-scrolling:touch;scrollbar-width:thin}' +
    '.dn-x__carousel .dn-c{flex:0 0 240px;scroll-snap-align:start}' +
    '@media(max-width:640px){.dn-x__grid{grid-template-columns:repeat(2,minmax(0,1fr))}}' +
    '@media(max-width:1000px) and (min-width:641px){.dn-x__grid{' +
    'grid-template-columns:repeat(3,minmax(0,1fr))}}' +
    /* a single card keeps a card\'s width instead of stretching across the row */
    '.dn-x__grid[data-n="1"],.dn-x__grid[data-n="2"]{' +
    'grid-template-columns:repeat(3,minmax(0,300px))}' +
    '.dn-c{background:var(--paper);border:1px solid var(--line);border-radius:6px;overflow:hidden;' +
    'display:flex;flex-direction:column}' +
    '.dn-c__imw{position:relative;display:block}' +
    '.dn-c__im{aspect-ratio:1/1;background:#F1EBE0 center/cover no-repeat;display:block}' +
    '.dn-c__b{padding:12px 13px 13px;display:flex;flex-direction:column;gap:6px;flex:1}' +
    '.dn-c__t{font-size:1rem;line-height:1.3;text-decoration:none;color:var(--ink)}' +
    '.dn-c__p{font-weight:600;margin-top:auto}' +
    /* the button sits ON the image, per the brief; a scrim keeps it legible over a
       white-sweep cutout as well as over a dark lifestyle shot */
    '.dn-c__btn{position:absolute;left:10px;right:10px;bottom:10px;' +
    'font-family:Mulish,system-ui,sans-serif;font-weight:700;' +
    'font-size:.68rem;letter-spacing:.09em;text-transform:uppercase;border:0;border-radius:100px;' +
    'padding:10px 12px;background:rgba(34,25,19,.92);color:#F7F3EA;cursor:pointer;' +
    'backdrop-filter:saturate(1.2);transition:background .18s ease,color .18s ease}' +
    '.dn-c:hover .dn-c__btn{background:#221913}' +
    '.dn-c__btn[disabled]{cursor:default}' +
    '.dn-c__btn.ok{background:var(--greenbg);color:var(--green)}' +
    '.dn-r{display:flex;flex-direction:column;gap:9px}' +
    '.dn-r a{display:block;padding:13px 15px;border:1px solid var(--line);border-radius:6px;' +
    'text-decoration:none;color:var(--ink);background:var(--paper);font-size:1.02rem}' +
    '.dn-r a:hover{border-color:var(--gold)}.dn-r a span{color:var(--goldd)}' +
    /* stone rows: 3 cards for a named stone + a Shop-all button, used by tool results */
    '.dn-stone-row .dn-x__grid{justify-content:center}' +
    '.dn-stone-all{display:flex;gap:10px;justify-content:center;flex-wrap:wrap;margin-top:18px}' +
    '.dn-stone-all a{font-family:Mulish,system-ui,sans-serif;font-weight:700;font-size:.72rem;' +
    'letter-spacing:.09em;text-transform:uppercase;text-decoration:none;border-radius:100px;' +
    'padding:12px 22px;background:linear-gradient(180deg,#DCC07A,#C6A24C);color:#241a0c}' +
    '.dn-stone-all a.g{background:transparent;border:1px solid rgba(43,38,34,.18);color:var(--ink)}' +
    '.dn-stone-all a.g:hover{border-color:var(--gold)}';
  var s = document.createElement('style'); s.textContent = CSS; document.head.appendChild(s);

  function money(p) { return '£' + (p / 100).toFixed(2); }

  /* DNPCACHE: session cache for the row fetches. Every page view was re-fetching
     suggest.json + product .js, so rows popped in late on every navigation — on phones
     that read as the page "loading anew" while scrolling. 30-minute TTL; prices and
     stock move slower than a browsing session, and a stale price corrects on the
     product page. sessionStorage can throw (private mode) — every access is guarded. */
  function cachedJSON(key, fetcher) {
    var TTL = 30 * 60 * 1000;
    try {
      var hit = sessionStorage.getItem('dnp:' + key);
      if (hit) {
        var obj = JSON.parse(hit);
        if (Date.now() - obj.t < TTL) return Promise.resolve(obj.v);
      }
    } catch (e) {}
    return fetcher().then(function (v) {
      try { sessionStorage.setItem('dnp:' + key, JSON.stringify({ t: Date.now(), v: v })); } catch (e) {}
      return v;
    });
  }

  function card(h) {
    var el = document.createElement('div'); el.className = 'dn-c';
    /* el._ready resolves to {v, p, img} once the card has rendered (null if it was dropped), so a
       caller can total the row for the Add All box */
    el._ready = cachedJSON('p:' + h, function () {
      return fetch('/products/' + h + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw 0; return r.json(); })
        .then(function (p) {
          return { title: p.title, featured_image: p.featured_image,
                   images: p.images && p.images.slice(0, 1),
                   variants: (p.variants || []).map(function (x) {
                     return { id: x.id, price: x.price, available: x.available };
                   }) };
        });
    })
      .then(function (p) {
        var v = (p.variants || []).filter(function (x) { return x.available; })[0] || p.variants[0];
        if (!v) { el.remove(); return null; }
        var img = p.featured_image || (p.images && p.images[0]) || '';
        el.innerHTML =
          '<div class="dn-c__imw"><a class="dn-c__im" href="/products/' + h + '"' +
          (img ? ' style="background-image:url(' + img + '&width=500)"' : '') + '></a>' +
          '<button class="dn-c__btn" type="button">Add to basket</button></div>' +
          '<div class="dn-c__b"><a class="dn-c__t" href="/products/' + h + '">' + p.title + '</a>' +
          '<div class="dn-c__p">' + money(v.price) + '</div></div>';
        var btn = el.querySelector('.dn-c__btn');
        btn.addEventListener('click', function () {
          btn.disabled = true; btn.textContent = 'Adding…';
          fetch('/cart/add.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] })
          }).then(function (r) {
            if (!r.ok) throw 0;
            btn.textContent = 'Added ✓'; btn.classList.add('ok');
            document.dispatchEvent(new CustomEvent('cart:updated'));
            if (window.DNCart && window.DNCart.celebrate) window.DNCart.celebrate();
            setTimeout(function () {
              btn.textContent = 'Add to basket'; btn.classList.remove('ok'); btn.disabled = false;
            }, 2200);
          }).catch(function () { btn.textContent = 'Try again'; btn.disabled = false; });
        });
        return { v: v.id, p: v.price, img: img };
      })
      .catch(function () { el.remove(); return null; });
    return el;
  }

  /* DNKITSET (29 Oct 2026): on the quiz-kit tool pages (.dnk-skin) a full row of three ends on the
     quiz kit's Add All box and the £25 / £40 / £60 ladder, so a result finishes on the basket rather
     than on a Shop-all link. Wording is the quiz kit's (ChatGPT, data/funnels/quiz/kit_labels.txt).
     Styles live in assets/dn-quiz-kit-tools.css. */
  function kitPaid(c) {
    var paid = 0;
    (c.items || []).forEach(function (it) { if (!(it.properties && it.properties._gift)) paid += it.final_line_price; });
    return paid;
  }
  function kitLadder(box, cart) {
    (cart ? Promise.resolve(cart) : fetch('/cart.js').then(function (r) { return r.json(); }))
      .then(function (c) {
        var paid = kitPaid(c), m = box.querySelector('.dn-set__msg');
        box.querySelectorAll('.dn-set__ms span').forEach(function (n) { n.classList.toggle('on', paid >= +n.getAttribute('data-min')); });
        box.querySelector('.dn-set__lad i').style.width = Math.min(100, paid / 6000 * 100) + '%';
        if (paid < 2500) m.innerHTML = 'Spend <b>' + money(2500 - paid) + '</b> more to unlock a free crystal';
        else if (paid < 4000) m.innerHTML = '<b>' + money(4000 - paid) + '</b> more for free UK delivery';
        else if (paid < 6000) m.innerHTML = '<b>' + money(6000 - paid) + '</b> more for a second free gift';
        else m.innerHTML = '&#10003; All rewards unlocked';
      }).catch(function () {});
  }
  function kitAnnounce(cart) {
    try {
      import('@shopify/events').then(function (m) {
        var E = m.CartLinesUpdateEvent, d = E.createPromise();
        document.dispatchEvent(new E({ action: 'add', context: 'cart', lines: [], promise: d.promise }));
        d.resolve({ cart: E.createCartFromAjaxResponse(cart), detail: { source: 'dn-kit-set', items: cart.items } });
      }).catch(function () {});
    } catch (e) {}
  }
  function kitSet(host, cards) {
    if (!host.closest('.dnk-skin')) return;
    Promise.all(cards.map(function (c) { return c._ready; })).then(function (list) {
      var it = list.filter(Boolean);
      if (it.length < 3 || host.querySelector('.dn-set')) return;
      var tot = it.reduce(function (a, k) { return a + k.p; }, 0);
      var box = document.createElement('div'); box.className = 'dn-set';
      box.innerHTML = '<span class="dn-set__cap">Add All Three</span><div class="dn-set__l">' +
        '<div class="dn-set__sr"><div class="dn-set__th">' + it.map(function (k) {
          return '<img src="' + k.img + (k.img.indexOf('?') > 0 ? '&' : '?') + 'width=120" alt="" width="42" height="42">'; }).join('') +
        '</div><b class="dn-set__h">All Three</b><span class="dn-set__tot">' + money(tot) + '</span></div>' +
        '<div class="dn-set__lad"><i></i></div><div class="dn-set__ms"><span data-min="2500"><b>£25</b>Free crystal</span>' +
        '<span data-min="4000"><b>£40</b>Free UK delivery</span><span data-min="6000"><b>£60</b>Second free gift</span></div>' +
        '<p class="dn-set__msg"></p><button class="dn-set__btn" type="button">Add All · ' + money(tot) + '</button>' +
        '<a class="dn-set__cart" href="/cart" hidden>View Basket</a></div>';
      host.appendChild(box);
      kitLadder(box);
      document.addEventListener('cart:updated', function () { setTimeout(function () { kitLadder(box); }, 400); });
      var btn = box.querySelector('.dn-set__btn');
      btn.addEventListener('click', function () {
        btn.disabled = true; btn.textContent = 'Adding';
        fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: it.map(function (k) { return { id: k.v, quantity: 1 }; }) }) })
          .then(function (r) { if (!r.ok) throw 0; return fetch('/cart.js'); })
          .then(function (r) { return r.json(); })
          .then(function (c) {
            btn.textContent = 'Added'; box.querySelector('.dn-set__cart').hidden = false;
            kitAnnounce(c); kitLadder(box, c); setTimeout(function () { kitLadder(box); }, 1500);
            if (window.DNCart && window.DNCart.celebrate) window.DNCart.celebrate();
          })
          .catch(function () { btn.disabled = false; btn.textContent = 'Add All · ' + money(tot); });
      });
    });
  }

  /* Render one .dn-picks host. Exposed as DNPicks.mount so a section that only learns its
     handles at runtime (dn-also-like fetches them from the recommendations API) gets the same
     card, the same 3-up grid and the same Add to cart as every other block on the page. */
  function mount(host) {
    if (!host || host.dataset.dnMounted) return;
    var max = parseInt(host.getAttribute('data-max'), 10) || 3;
    var hs = (host.getAttribute('data-handles') || '').split(',').map(function (x) { return x.trim(); })
      .filter(Boolean).slice(0, max);
    if (!hs.length) return;
    host.dataset.dnMounted = '1';
    host.classList.add('dn-x');
    var t = host.getAttribute('data-title'), sub = host.getAttribute('data-sub');
    host.innerHTML = (t ? '<h2 class="dn-x__h">' + t + '</h2>' : '') +
                     (sub ? '<p class="dn-x__s">' + sub + '</p>' : '');
    var g = document.createElement('div');
    g.className = host.hasAttribute('data-carousel') ? 'dn-x__carousel' : 'dn-x__grid';
    g.setAttribute('data-n', String(hs.length));
    var cs = hs.map(function (h) { var c = card(h); g.appendChild(c); return c; });
    host.appendChild(g);
    if (host.hasAttribute('data-kit')) kitSet(host, cs);
  }

  document.querySelectorAll('.dn-picks[data-handles]').forEach(mount);

  /* Render 3 real products for a stone NAME, plus a "Shop all X" button. Tool results only
     know the stone after the reveal, so this resolves handles at runtime via predictive
     search, filtered the same way as every other row: available, title actually names the
     stone, no bulk artefacts. If the catalogue is thin the row degrades to the button alone
     rather than an empty grid. */
  var BULK = /(bulk|case of|display|assorted|mixed|set of|\d\s*kg|pieces|pack of|box of)/i;
  function stoneRow(host) {
    if (!host || host.dataset.dnMounted) return;
    var stone = host.getAttribute('data-stone');
    if (!stone) return;
    host.dataset.dnMounted = '1';
    host.classList.add('dn-x');
    var searchUrl = '/search?q=' + encodeURIComponent(stone);
    /* data-label: the words shown in "Shop all ..." when the search term reads badly there */
    var btns = '<a href="' + searchUrl + '">Shop all ' + (host.getAttribute('data-label') || stone) + ' &rarr;</a>';
    (host.getAttribute('data-more') || '').split(',').forEach(function (x) {
      var p = x.split('|');
      if (p[0] && p[1]) btns += '<a class="g" href="' + p[1] + '">' + p[0] + '</a>';
    });
    var grid = document.createElement('div');
    var all = document.createElement('div');
    all.className = 'dn-stone-all'; all.innerHTML = btns;
    /* on kit pages the Shop-all links sit small above the row, so the result ends on the basket */
    if (host.closest('.dnk-skin')) { host.appendChild(all); host.appendChild(grid); }
    else { host.appendChild(grid); host.appendChild(all); }
    var kit = !!host.closest('.dnk-skin');
    function find(term) {
      return cachedJSON('s:' + term, function () {
        return fetch('/search/suggest.json?q=' + encodeURIComponent(term) +
              '&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=hide',
              { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : null; });
      }).then(function (d) {
        var lc = term.toLowerCase();
        var hs = (((d || {}).resources || {}).results || {}).products || [];
        hs = hs.filter(function (p) {
          return p.available !== false && !BULK.test(p.title) &&
                 p.title.toLowerCase().indexOf(lc) !== -1;
        });
        /* kit pages total the row in an Add All box, so they show the three most affordable matches */
        if (kit) hs.sort(function (a, b) { return parseFloat(a.price) - parseFloat(b.price); });
        return hs.map(function (p) { return p.handle; }).slice(0, 3);
      });
    }
    /* on kit pages a stone with nothing in stock falls back to the other stones named in the row's
       Shop links, then to crystals in general, so the result still ends on products */
    var terms = [stone];
    if (kit) {
      (host.getAttribute('data-more') || '').split(',').forEach(function (x) {
        var m = /[?&]q=([^&]+)/.exec(x.split('|')[1] || '');
        if (m) terms.push(decodeURIComponent(m[1]));
      });
      terms.push('crystal');
    }
    (function next(k) {
      if (k >= terms.length) return Promise.resolve([]);
      return find(terms[k]).then(function (hs) { return hs.length >= (kit ? 3 : 1) || k === terms.length - 1 ? hs : next(k + 1); });
    })(0)
      .then(function (hs) {
        if (!hs.length) return;
        grid.className = 'dn-x__grid';
        grid.setAttribute('data-n', String(hs.length));
        var cs = hs.map(function (h) { var c = card(h); grid.appendChild(c); return c; });
        kitSet(host, cs);
      })
      .catch(function () {});
  }
  document.querySelectorAll('.dn-stone-row[data-stone]').forEach(stoneRow);

  /* Tool results inject their markup after the reveal — mount whatever appears. */
  new MutationObserver(function (muts) {
    muts.forEach(function (m) {
      Array.prototype.forEach.call(m.addedNodes, function (n) {
        if (n.nodeType !== 1) return;
        if (n.matches) {
          if (n.matches('.dn-picks[data-handles]')) mount(n);
          if (n.matches('.dn-stone-row[data-stone]')) stoneRow(n);
        }
        if (n.querySelectorAll) {
          n.querySelectorAll('.dn-picks[data-handles]').forEach(mount);
          n.querySelectorAll('.dn-stone-row[data-stone]').forEach(stoneRow);
        }
      });
    });
  }).observe(document.body, { childList: true, subtree: true });

  window.DNPicks = { mount: mount, stoneRow: stoneRow };

  document.querySelectorAll('.dn-reads[data-articles]').forEach(function (host) {
    var items = host.getAttribute('data-articles').split(',').map(function (x) {
      var p = x.split('|'); return { h: (p[0] || '').trim(), t: (p[1] || '').trim() };
    }).filter(function (x) { return x.h && x.t; });
    if (!items.length) return;
    host.classList.add('dn-x');
    var t = host.getAttribute('data-title');
    host.innerHTML = (t ? '<h2 class="dn-x__h">' + t + '</h2>' : '');
    var w = document.createElement('div'); w.className = 'dn-r';
    items.forEach(function (i) {
      w.insertAdjacentHTML('beforeend',
        '<a href="/blogs/news/' + i.h + '">' + i.t + ' <span>&rarr;</span></a>');
    });
    host.appendChild(w);
  });
})();
